import {
    CLICK_ACTIONS,
    IMPRESSION_ACTIONS,
    SCREEN_NAME,
    SCREEN_VIEW_ACTIONS,
} from "@payment-client/analytics/constants";
import { AnalyticsContextValue } from "@swiggy-private/checkout-core";

//CLICK EVENT
export const onCheckboxSecureCardClickEvent = (
    screenName: string,
    value: number,
    context: string,
    clickEvent: AnalyticsContextValue["clickEvent"],
): void => {
    clickEvent({
        label: value,
        context: context,
        category: screenName,
        action: CLICK_ACTIONS.CLICK_CHECKBOX_SECURE_CARD,
    });
};

export const onClickOptionsClickEvent = (
    screenName: string,
    context: string,
    value: string,
    clickEvent: AnalyticsContextValue["clickEvent"],
): void => {
    clickEvent({
        category: screenName,
        context: context,
        label: value,
        action: CLICK_ACTIONS.CLICK_OPTIONS,
    });
};

export const onPayPennyDropClickEvent = (clickEvent: AnalyticsContextValue["clickEvent"]): void => {
    clickEvent({
        category: SCREEN_NAME.PAYMENT_MODES,
        action: CLICK_ACTIONS.CLICK_PAY_PENNY_DROP,
    });
};

export const onAddNewCardPayClickEvent = (
    screenName: string,
    clickEvent: AnalyticsContextValue["clickEvent"],
): void => {
    clickEvent({
        category: screenName,
        action: CLICK_ACTIONS.CLICK_ADD_CARD_PAY,
    });
};
export const onSaveCardClickEvent = (clickEvent: AnalyticsContextValue["clickEvent"]): void => {
    clickEvent({
        category: SCREEN_NAME.PAYMENT_MODES,
        action: CLICK_ACTIONS.CLICK_SAVE_CHANGES,
    });
};
export const onSecureCardClickEvent = (clickEvent: AnalyticsContextValue["clickEvent"]): void => {
    clickEvent({
        category: SCREEN_NAME.PAYMENT_MODES,
        action: CLICK_ACTIONS.CLICK_SAVE_SECURE_CHANGES,
    });
};

export const onSavedCardPayButtonClickEvent = (
    screenName: string,
    clickEvent: AnalyticsContextValue["clickEvent"],
): void => {
    clickEvent({
        category: screenName,
        action: CLICK_ACTIONS.CLICK_CARD_PAY,
    });
};

export const onKnowMoreTokenizationClickEvent = (
    screenName: string,
    clickEvent: AnalyticsContextValue["clickEvent"],
): void => {
    clickEvent({
        category: screenName,
        action: CLICK_ACTIONS.CLICK_KNOW_MORE_CARD_TOKENIZATION,
    });
};

export const onProceedToPayClickEvent = (
    screenName: string,
    context: string,
    clickEvent: AnalyticsContextValue["clickEvent"],
): void => {
    clickEvent({
        context: context,
        category: screenName,
        action: CLICK_ACTIONS.CLICK_PROCEED,
    });
};

//SCREEN VIEW EVENT
export const onAddNewCardScreenViewEvent = (
    screenName: string,
    screenViewEvent: AnalyticsContextValue["screenViewEvent"],
): void => {
    screenViewEvent({
        category: screenName,
        action: SCREEN_VIEW_ACTIONS.VIEW_ADD_NEW_CARD,
    });
};
export const onManageCardScreenViewEvent = (screenViewEvent: AnalyticsContextValue["screenViewEvent"]): void => {
    screenViewEvent({
        category: SCREEN_NAME.PAYMENT_MODES,
        action: SCREEN_VIEW_ACTIONS.VIEW_MANAGE_CARD_SCREEN,
    });
};

export const onTokenisationHalfCardScreenViewEvent = (
    screenName: string,
    screenViewEvent: AnalyticsContextValue["screenViewEvent"],
): void => {
    screenViewEvent({
        category: screenName,
        action: SCREEN_VIEW_ACTIONS.VIEW_TOKENIZATION_GUIDELINES_HALF_CARD,
    });
};

export const skipCVVImpressionEvent = (
    screenName: string,
    impressionEvent: AnalyticsContextValue["impressionEvent"],
): void => {
    impressionEvent({
        category: screenName,
        action: IMPRESSION_ACTIONS.IMPRESSION_SKIP_CVV,
    });
};

export const onCvvScreenViewEvent = (
    context: string,
    screenViewEvent: AnalyticsContextValue["screenViewEvent"],
): void => {
    screenViewEvent({
        category: SCREEN_NAME.PAYMENT_MODES,
        action: SCREEN_VIEW_ACTIONS.VIEW_PENNY_DROP_SCREEN,
        context,
    });
};

export const onSecureCardSuccessView = (screenViewEvent: AnalyticsContextValue["screenViewEvent"]): void => {
    screenViewEvent({
        category: SCREEN_NAME.PAYMENT_MODES,
        action: SCREEN_VIEW_ACTIONS.VIEW_CARD_SECURED_SUCCESS,
    });
};

export const onCardNotEligibleEmiCroutonImpressionEvent = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    message: string,
    emiPage?: boolean,
): void => {
    impressionEvent({
        category: SCREEN_NAME.ADD_NEW_CARD,
        action: IMPRESSION_ACTIONS.IMPRESSION_CARD_NOT_ELIGIBLE_CROUTON,
        context: JSON.stringify({
            message: message,
            emiPage: emiPage,
        }),
    });
};

export const onPayInEMIClickEvent = (screenName: string, clickEvent: AnalyticsContextValue["clickEvent"]): void => {
    clickEvent({
        category: screenName,
        action: CLICK_ACTIONS.CLICK_CARD_EMI,
    });
};
